import ExternalApiRequest from '../externalApiRequest';

const getLeftNav = async () => {
    try {
        const options = {
            api: 'leftNav'
        };
        return await ExternalApiRequest(options);
    } catch (error) {
        return '';
    }

};

export default getLeftNav;
